import { Component, Input, OnInit, Output } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { DIALOG_EXIT_CODE } from "@constants/api";
import { DialogRef } from "@progress/kendo-angular-dialog";
import { Subject, takeUntil } from "rxjs";
import { AuthService } from "src/app/auth/services/auth.service";
import { FrameRequestMappedStatuses } from "src/app/core/enums";
import { RequestsService } from "src/app/core/services/requests.service";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-text-editor',
    templateUrl: './rich-text-editor.component.html',
    styleUrls: ['./rich-text-editor.component.scss']
})
export class RichTextEditorComponent implements OnInit {

    @Input() document: any;
    iFrameSrc: string = "";
    isLoading: boolean = false;
    DIALOG_EXIT_CODE = DIALOG_EXIT_CODE;
    private _destroy$: Subject<any> = new Subject<any>();

    get completeLabel() {
        return this.auth.isMedikoUser ? 'Изпрати за одобрение' : 'Одобри';
    }

    get isCompleteDisabled() {
        if (!this.document || !this.document.statusId) return true;
        if (this.auth.isMedikoUser) {
            if (this.document.statusId !== FrameRequestMappedStatuses.Checking &&
                (this.document.statusId >= FrameRequestMappedStatuses.New && this.document.statusId <= FrameRequestMappedStatuses.Success)) 
                return false;
            return true;
        } else {
            if (this.document.statusId === FrameRequestMappedStatuses.Checking) return false;
            return true; 
        }
    }

    constructor(
        private domSanitazier: DomSanitizer,
        private dialogRef: DialogRef,
        private auth: AuthService,
        private requestService: RequestsService,
    ) {}

    ngOnInit(): void {
        const url = `${environment.richTextEditorUrl}/document/get/${this.document.id}`;
        this.iFrameSrc = this.domSanitazier.bypassSecurityTrustResourceUrl(url) as string;
    }   

    onClose(exitResult: any) {
        this.dialogRef.close(exitResult);
    }

    onComplete(): void {
        const payload = {
            id: this.document.id,
            statusId: this.auth.isMedikoUser ? FrameRequestMappedStatuses.Checking : FrameRequestMappedStatuses.Approved
        }
        this.requestService.updateRequestDocumentStatus(payload)
            .pipe(takeUntil(this._destroy$))
            .subscribe(_ => {
                this.onClose(DIALOG_EXIT_CODE.RESOLVE);
            })
    }
}